import { useEffect, useState } from "react";
import { fetchAlerts } from "../api/fetchAlerts";

function useAssetAlert(assetIds: string[]) {
    const [alerts, setAlerts] = useState<any[]>([]);
    const [alertSidebar, setAlertSidebar] = useState(false);
    const [assetAlerts, setAssetAlerts] = useState<any[]>([]);

    useEffect(() => {
        getAlerts(assetIds);
    }, [assetIds.length]);

    const getAlerts = async (assetIds: string[]) => {
        const today = new Date();
        const startAt = new Date(today.getTime() - 7 * 24 * 60 * 60 * 1000).toISOString();
        const endAt = new Date().toISOString();

        const bodyData = {
            pageSize: 1000,
            page: 0,
            assetIds,
            tagIds: [],
            lampFilter: [],
            startAt: startAt,
            endAt: endAt,
            search: "",
            zone: "UTC-3",
        };

        try {
            const alertsResponse = await fetchAlerts(bodyData);
            setAlerts(alertsResponse ?? []);
        } catch (error) {
            console.error("Erro ao buscar alertas:", error);
            setAlerts([]);
        }
    }

    const hasAlert = (assetId: string): boolean => {
        if (!assetId && !alerts.length) return false;
        return alerts.some((alert) => alert?.vehicleId === assetId);
    };

    const hasCriticalAlert = (assetId: string): boolean => {
        if (!assetId && !alerts.length) return false;
        return alerts.some((alert) => 
            alert?.vehicleId === assetId && 
            (alert?.lampStatus === "RED" || alert?.lampStatus === "PROTECTED")
        );
    };

    const getCriticalAlertCount = (assetId: string): number => {
        if (!assetId && !alerts.length) return 0;
        return alerts.filter((alert) => 
            alert?.vehicleId === assetId && 
            (alert?.lampStatus === "RED" || alert?.lampStatus === "PROTECTED")
        ).length;
    };

    const handleAlertSidebar = (assetId: string) => {
        if (!assetId) return;
        const alert = alerts?.find((alert) => alert?.vehicleId === assetId);
        const assetAlerts = alerts?.filter((alert) => alert?.vehicleId === assetId);
        if (!alert || !assetAlerts.length) return;
        setAlertSidebar(!alertSidebar);
        setAssetAlerts(assetAlerts);
    };

    const handleCloseAlertSidebar = () => {
        setAlertSidebar(false);
        setAssetAlerts([]);
    };

    return { 
        hasAlert, 
        hasCriticalAlert, 
        getCriticalAlertCount, 
        handleAlertSidebar, 
        handleCloseAlertSidebar, 
        alertSidebar, 
        assetAlerts 
    };
}

export default useAssetAlert;